module.exports = __webpack_public_path__ + "img/canbadge_animal_w60mm_trimmark.0f8784ab.png";